import { render, staticRenderFns } from "./ShareholderModal.vue?vue&type=template&id=6cbb06c4&scoped=true&"
import script from "./ShareholderModal.vue?vue&type=script&lang=ts&"
export * from "./ShareholderModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShareholderModal.vue?vue&type=style&index=0&id=6cbb06c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbb06c4",
  null
  
)

export default component.exports